"use strict";

exports.__esModule = true;
exports.TimelineAddColumnField = TimelineAddColumnField;
var _react = _interopRequireDefault(require("react"));
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// TODO: Select columns here

// Pull out the columns from the definition not currently used on the table
function getColumnsFromDefinition(props) {
  var dataSourceDefinition = props.dataSourceDefinition;
  return dataSourceDefinition.columns.map(function (item) {
    return {
      id: item.id,
      name: item.name
    };
  });
}
function handleAddColumn(props, item) {
  var dataSourceDefinition = props.dataSourceDefinition,
    onAddColumn = props.onAddColumn;
  var definition = dataSourceDefinition.columns.find(function (columnDefinition) {
    return columnDefinition.id === item.id;
  });
  if (definition && onAddColumn) {
    onAddColumn(definition);
  }
}
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.name;
}
function itemPredicate(query, device) {
  var q = query.toLowerCase();
  return device.id.toLowerCase().indexOf(q) !== -1 || device.name.toLowerCase().indexOf(q) !== -1;
}
function TimelineAddColumnField(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _props$dataTestid = props["data-testid"],
    dataTestId = _props$dataTestid === void 0 ? "TimelineAddColumnField.button" : _props$dataTestid;
  var columns = getColumnsFromDefinition(props);
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    helperText: translate("TimelineTableFields.columns.helperText", "Hide/show columns and re-order.")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    filterable: false,
    onSelect: function onSelect(items) {
      return handleAddColumn(props, items[0]);
    },
    items: columns,
    getKey: getKey,
    renderItemText: renderItemText,
    itemPredicate: itemPredicate
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": dataTestId,
    text: translate("TimelineTableFields.columns.addLabel", "Add Column"),
    icon: _icons.IconNames.ADD_COLUMN_RIGHT
  })));
}